/**
 * HortiClub social proof: reveal the next batch of hidden review cards
 * on desktop/tablet. Mobile shows every review in the horizontal row
 * (no Load More — see revealAllReviewsOnMobile below).
 */
(function () {
  if (window.hortclubSocialProofInit) return;
  window.hortclubSocialProofInit = true;

  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function revealAllReviewsOnMobile() {
    if (!mobileQuery.matches) return;
    document.querySelectorAll('.hortclub-social-proof__row li[hidden]').forEach(function (item) {
      item.removeAttribute('hidden');
    });
    document.querySelectorAll('[data-hortclub-load-more]').forEach(function (btn) {
      btn.setAttribute('hidden', 'hidden');
    });
  }

  revealAllReviewsOnMobile();
  mobileQuery.addEventListener('change', function (event) {
    if (event.matches) revealAllReviewsOnMobile();
  });

  document.addEventListener('click', function (event) {
    if (mobileQuery.matches) return;

    var button = event.target.closest('[data-hortclub-load-more]');
    if (!button) return;

    var hidden = document.querySelectorAll('.hortclub-social-proof__row li[hidden]');
    Array.prototype.slice.call(hidden, 0, 8).forEach(function (item) {
      item.removeAttribute('hidden');
    });

    if (!document.querySelector('.hortclub-social-proof__row li[hidden]')) {
      document.querySelectorAll('[data-hortclub-load-more]').forEach(function (btn) {
        btn.setAttribute('hidden', 'hidden');
      });
    }
  });
})();
